import { Direction } from "../../../../types/battle-engine/battle";
import { SkillCastPattern } from ".";

export const SQUARE_1_PATTERN: SkillCastPattern = () => {
  return {
    [Direction.N]: [
      [1, 0],
      [1, -1],
      [0, -1],
      [-1, -1],
      [-1, 0],
      [-1, 1],
      [0, 1],
      [1, 1],
    ],

    [Direction.NE]: [],

    [Direction.E]: [],

    [Direction.SE]: [],

    [Direction.S]: [],

    [Direction.SW]: [],

    [Direction.W]: [],

    [Direction.NW]: [],
  };
};
